export enum TipoMensagemChat {
    PING = 'P',
    CHAT = 'C'
}
